/**
* Services Config
*/
export default function () {
  return {
    s3BucketName: 'CustomUSB',
    typeform: {
      enable: false,
      forms: {
        submitInquiry: '',
        submitInquiryNew: '',
        scheduleCall: '',
        requestAccess: '',
        requestAccessNew: ''
      }
    },
    pubbleApp: {
      enable: true,
      liveChat: 125993,
      hideOn: []
    },
    gtm: {
      dev: {
        id: 'GTM-N45RTBWC',
        enabled: true,
        debug: false,
        gtm_auth: 'm8HI04OVnf8b95ZA2IoTYg'
      },
      live: {
        id: 'GTM-N45RTBWC',
        enabled: true,
        debug: false,
        gtm_auth: '_BBgCrGRNCkJV4cVk70tXA'
      }
    }
  }
}
